<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader title="Branches"/>
  
      <!-- Branches Section -->
      <div class=" mt-4">
        <div class="row">
          <div class="col-12">
            <div class="text-right mb-3">
              <button class="add-language-btn" @click="createNewBranch">Create New Branch</button>
            </div>
            <div v-if="loading" class="text-center">Loading branches...</div>
            <div v-else>
              <!-- Branches Table -->
              <table>
                <thead>
                  <tr>
                    <!-- <th>ID</th> -->
                    <th>Name</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="branch in branches" :key="branch.id" class="action-buttons">
                    <!-- <td>{{ branch.id }}</td> -->
                    <td>{{ branch.name }}</td>
                    <td class="action-buttons">
                      <span :class="{'': branch.isSuspend === 0, '': branch.isSuspend === 1}">
                        {{ branch.isSuspend === 0 ? 'Active' : 'Suspended' }}
                      </span>
                    </td>
                    <td>
                      <button data-tooltip="Update" @click="editBranch(branch)">
                        <img src="@/assets/edit_icon.png" alt="Update">
                      </button>
                      <button data-tooltip="Delete" @click="deleteBranch(branch)">
                         <img src="@/assets/delete_icon.png" alt="Delete">
                      </button>
                       <button 
                      data-tooltip="Barcode" 
                      @click="navigateToBarcodeSegmentation(branch)"
                    >
                      <i class="bi bi-upc-scan"></i>
                    </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Footer -->
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        branches: [], 
        loading: true, 
        currentDate: '', 
        currentTime: '', 
      };
    },
    mounted() {
      this.updateDateTime();
      this.startDateTimeUpdate();
      this.fetchBranches();
    },
    methods: {
     navigateToBarcodeSegmentation(branch) {
        this.$router.push({ 
          name: "BarcodeSegmentation", 
          params: { id: branch.id } 
        });
      
    },
      async fetchBranches() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken');
          const response = await fetch(`${this.$BASE_API_URL}/api/branches`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });
  
          if (!response.ok) {
            throw new Error('Failed to fetch branches');
          }
  
          const data = await response.json();
          this.branches = data.data; // Store branches data
        } catch (error) {
          console.error('Error fetching branches:', error);
          this.$toast.error('Failed to load branches. Please try again.');
        } finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      createNewBranch() {
         if (this.$hasPermission('create branches')) {
              this.$router.push({ name: "AddBrancheComponent" });
    } else {
      this.$toast.error('Not Permitted');
    }
      },
      editBranch(branch) {
          if (this.$hasPermission('edit branches')) {
            this.$router.push({ name: "EditBrancheComponent", params: { id: branch.id} });
    } else {
      this.$toast.error('Not Permitted');
    }
      },
      async deleteBranch(branch) {
          if (!this.$hasPermission('delete branches')) {
                   this.$toast.error('Not Permitted');
                   return;
    } 
  if (confirm(`Are you sure you want to delete branch?`)) {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${this.$BASE_API_URL}/api/branches/${branch.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 204) {
        this.$toast.success('Branch deleted successfully!');
        this.fetchBranches(); 
      } else {
        throw new Error('Failed to delete branch');
      }
    } catch (error) {
      console.error('Error deleting branch:', error);
      this.$toast.error('Failed to delete branch. Please try again.');
    }
  }
},
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        this.currentTime = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      },
      startDateTimeUpdate() {
        setInterval(() => {
          this.updateDateTime();
        }, 1000);
      },
    },
  };
  </script>
  
  <style scoped>
  .container {
    max-width: 800px;
    margin: 0 auto;
  }
  
.action-buttons button {
    background: none;
    border: none;
    cursor: pointer;
    margin: 0 5px;
    position: relative;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }
  .action-buttons button:hover {
    transform: scale(1.2); 
    opacity: 0.8; 
  }
  .action-buttons button:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
  }
  .action-buttons button img {
    width: 20px;
    height: 20px;
  }
  /* Icon Colors */
  .bi.bi-upc-scan{
      filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(270deg); /* Purple-ish */

  }
  .action-buttons button[data-tooltip="Barcode"] img {
  filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(270deg); /* Purple-ish */
}
  .action-buttons button[data-tooltip="Menu"] img {
    filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(180deg); /* Blue */
  }
  .action-buttons button[data-tooltip="Update"] img {
    filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(90deg); /* Green */
  }
  .action-buttons button[data-tooltip="Suspend"] img {
    filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(45deg); /* Orange */
  }

  .action-buttons button[data-tooltip*="Hot Key"] img {
    filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(0deg); /* Red-Orange */
  }

.action-buttons button[data-tooltip="Tax"] img {
  filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(210deg); /* Blue-ish */
}

.action-buttons button[data-tooltip="Customize"] img {
  filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(300deg); /* Pink-ish */
}
  .add-language-btn {
  padding: 10px;
  background-color: #4caf50;
  border: none;
  cursor: pointer;
  width: max-content;
  border-radius: 5px;
  margin-right: 1rem;
}
  

  </style>